import styled, { css } from 'styled-components';
import ScrollUpButton from 'react-scroll-up-button';

import { media, color, zIndex } from 'app/shared/styles_js/variables';
import { NavigationMenu } from 'app/shared/components/NavigationMenu/NavigationMenu';
import { headerHeight, mobileHeaderHeight } from 'app/dealer/common.css';

export const DealerPageContainerSt = styled.div`
  position: relative;

  ${({ showMenu }) => css`
    margin-top: ${showMenu ? '0px' : '64px'};
    padding-top: ${showMenu ? `${mobileHeaderHeight + 56}px` : '0px'};

    ${media.md(css`
      padding-top: ${showMenu ? `${headerHeight + 80}px` : '0px'};
    `)};
    ${media.lg(css`
      padding-top: ${showMenu ? `${headerHeight + 96}px` : '0px'};
    `)};
  `}

  .backToTopButtonContainer {
    position: fixed;
    z-index: ${zIndex.navbar + 1};

    right: -100px;
    bottom: ${({ shouldShowBottomPrompt }) =>
      shouldShowBottomPrompt ? '96px' : '56px'};

    transition: right 0.5s;
    background-color: transparent;
    font-size: 20px;

    &.backToTopButtonTransition {
      right: 32px;
      ${media.md(
        css`
          right: 28px;
        `
      )};
      ${media.lg(
        css`
          right: 36px;
        `
      )};
      ${media.xl(
        css`
          right: 56px;
        `
      )};
    }
  }
`;

export const NavigationMenuSt = styled(NavigationMenu)`
  display: none;

  ${media.md(
    css`
      display: block;
    `
  )};
`;

export const ScrollUpButtonWrapperSt = styled(ScrollUpButton)``;

export const BackToTopSt = styled.button`
  width: 64px;
  height: 64px;
  border: 0;
  border-radius: 100%;
  cursor: pointer;
  transition: background-color 250ms;
  background-color: ${({ dockBackToTopInFooter }) =>
    dockBackToTopInFooter ? color.brandPrimary : color.brandSecondary};

  &:hover {
    background-color: ${({ dockBackToTopInFooter }) =>
      dockBackToTopInFooter
        ? color.brandPrimaryLight
        : color.brandSecondaryLighter};
  }

  &:active {
    background-color: ${({ dockBackToTopInFooter }) =>
      dockBackToTopInFooter ? color.brandPrimaryDark : color.brandSecondary};
  }

  i {
    &:hover {
      color: #fff;
    }
  }
`;
